/* ============================================================
   MALIBEE — Shared JS for interactive sections
   File: assets/section-malibee.js
   ============================================================ */

(function () {
  'use strict';

  function init() {
    initBeforeAfter();
    initComparisonTabs();
    initFAQ();
  }

  /* ────────── Before/After draggable slider ────────── */
  function initBeforeAfter() {
    document.querySelectorAll('[data-malibee-ba]').forEach(function (root) {
      var mask = root.querySelector('.m-ba__before-mask');
      var handle = root.querySelector('.m-ba__handle');
      var beforeImg = root.querySelector('.m-ba__before');
      var tabs = root.parentElement.querySelectorAll('[data-malibee-ba-tab]');
      var dragging = false;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        mask.style.width = pct + '%';
        handle.style.left = pct + '%';
        if (beforeImg) beforeImg.style.width = (100 / pct * 100) + '%';
      }

      function onMove(clientX) {
        var rect = root.getBoundingClientRect();
        var x = clientX - rect.left;
        setPos((x / rect.width) * 100);
      }

      root.addEventListener('mousedown', function (e) { dragging = true; onMove(e.clientX); });
      root.addEventListener('touchstart', function (e) { dragging = true; if (e.touches[0]) onMove(e.touches[0].clientX); }, { passive: true });
      document.addEventListener('mouseup', function () { dragging = false; });
      document.addEventListener('touchend', function () { dragging = false; });
      document.addEventListener('mousemove', function (e) { if (dragging) onMove(e.clientX); });
      document.addEventListener('touchmove', function (e) { if (dragging && e.touches[0]) onMove(e.touches[0].clientX); }, { passive: true });

      setPos(50);

      // Tabs for swapping pairs
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('active'); });
          tab.classList.add('active');
          var before = tab.getAttribute('data-before');
          var after = tab.getAttribute('data-after');
          if (before) root.querySelector('.m-ba__before').setAttribute('src', before);
          if (after) root.querySelector('.m-ba__after').setAttribute('src', after);
          setPos(50);
        });
      });
    });
  }

  /* ────────── Comparison table tabs ────────── */
  function initComparisonTabs() {
    document.querySelectorAll('[data-malibee-comp]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-malibee-comp-tab]');
      var panels = root.querySelectorAll('[data-malibee-comp-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-malibee-comp-tab');
          tabs.forEach(function (t) { t.classList.toggle('active', t === tab); });
          panels.forEach(function (p) {
            p.classList.toggle('active', p.getAttribute('data-malibee-comp-panel') === key);
          });
        });
      });
    });
  }

  /* ────────── FAQ accordion ────────── */
  function initFAQ() {
    document.querySelectorAll('[data-malibee-faq]').forEach(function (root) {
      var items = root.querySelectorAll('.m-faq__item');
      items.forEach(function (item, idx) {
        var btn = item.querySelector('.m-faq__q');
        if (idx === 0) item.classList.add('open');
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('open');
          items.forEach(function (i) { i.classList.remove('open'); });
          if (!isOpen) item.classList.add('open');
        });
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();